import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import productAccessory from '../models/productAccessory';

declare const window: any;

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_PRODUCT_CDN ?? "https://cdn-npr-product.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Product'],
    endpoints: (builder) => ({
        getAccessoriesInfo: builder.query({
            query: (data) => ({
                url : `v1/products/${data.id}/accessoryInfo?locale=${data.locale}`,
                method: 'GET',
            }),
            transformResponse(response: any) {
                return response.map((accessory) => new productAccessory(accessory))
            }
        }),
    }),
})

export const {
    useGetAccessoriesInfoQuery,
} = productApi;